import { useTranslation } from "react-i18next";

export const chipStyles = (params: { value: string }) => {
  let bgColor = "transparent";
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation();

  const textColor = "rgba(0, 0, 0, 0.6)";

  const borderColor = "rgba(0, 0, 0, 0.23)";

  switch (params.value) {
    case "en-gb":
      bgColor = "rgba(250, 234, 247, 1)";
      break;
    case "en-us":
      bgColor = "rgba(224, 247, 250, 1)";
      break;
    case "de-de":
      bgColor = "rgba(237, 231, 246, 1)";
      break;
    case "de-at":
      bgColor = "rgba(255, 243, 224, 1)";
      break;
    case "fr-fr":
      bgColor = "rgba(224, 242, 241, 1)";
      break;
    case "es-419":
      bgColor = "rgba(249, 251, 231, 1)";
      break;
    case "zh-cn":
      bgColor = "rgba(232, 234, 246, 1)";
      break;
    case "it-it":
      bgColor = "rgba(251, 233, 231, 1)";
      break;
    case "ja-jp":
      bgColor = "rgba(250, 250, 250, 1)";
      break;
    case "pt-br":
      bgColor = "rgba(241, 248, 233, 1)";
      break;
    case "tr-tr":
      bgColor = "rgba(232, 245, 233, 1)";
      break;
    default:
      bgColor = "text.disabled";
  }

  return {
    sx: {
      color: textColor,
      height: "20px",
      backgroundColor: bgColor,
      padding: "3px 4px",
      border: `1px solid ${borderColor}`,
      fontWeight: 500,
    },
    label: t(`tts.toolbarMenu.languageMenu.${params.value}`),
  };
};
